import { navigateToStep } from '../../utils/navigate-to-step';
import { buildCampaignTypeUrl } from '../../../utils/url-builders';
import { EngageTracker } from '../../../tracking';
import { ENGAGE_CAMPAIGN_BUILDER_STEP_NAVIGATION } from '../../../tracking/events';
export var goToPreviousStep = function (params) {
    var previousStepPathname = buildCampaignTypeUrl({
        session: params.session,
        campaignId: params.campaignId,
    });
    EngageTracker.getInstance().track(ENGAGE_CAMPAIGN_BUILDER_STEP_NAVIGATION, {
        campaignId: params.campaignId || undefined,
        fromStep: 'configuration',
        toStep: 'type',
        direction: 'backward',
    });
    navigateToStep({
        store: params.store,
        navigate: params.navigate,
        stepPathname: previousStepPathname,
    });
};
